import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './ProjectSlider.css';

const ProjectSlider = ({ images = [] }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: 'center', skipSnaps: false, dragFree: false },
    [Autoplay({ delay: 4500, stopOnInteraction: false })]
  );

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);
  const scrollTo = useCallback((i) => emblaApi && emblaApi.scrollTo(i), [emblaApi]);
  const onInit = useCallback((api) => setScrollSnaps(api.scrollSnapList()), []);
  const onSelect = useCallback((api) => setSelectedIndex(api.selectedScrollSnap()), []);

  useEffect(() => {
    if (!emblaApi) return;
    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on('reInit', onInit);
    emblaApi.on('select', onSelect);
  }, [emblaApi, onInit, onSelect]);

  if (!images || images.length === 0) return null;

  return (
    <div className="project-slider">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {images.map((img, idx) => (
            <div className="embla__slide" key={`${img.src}-${idx}`}>
              <div className="project-slide">
                <img
                  src={img.src}
                  alt={img.alt || `Zdjęcie ${idx + 1}`}
                  loading="lazy"
                  className="project-slide__image"
                />
                {img.caption && (
                  <div className="project-slide__caption">
                    <span>{img.caption}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <button className="embla__button embla__button--prev" onClick={scrollPrev} aria-label="Poprzednie zdjęcie">
          <ChevronLeft size={22} />
        </button>
        <button className="embla__button embla__button--next" onClick={scrollNext} aria-label="Następne zdjęcie">
          <ChevronRight size={22} />
        </button>
      </div>

      <div className="embla__dots">
        {scrollSnaps.map((_, i) => (
          <button
            key={i}
            className={`embla__dot ${i === selectedIndex ? 'embla__dot--selected' : ''}`}
            onClick={() => scrollTo(i)}
            aria-label={`Idź do slajdu ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectSlider;
